import { PasswordComponent } from './components/basic/password/password.component';
import { DecoratorDirective } from './directives/decorator.directive';

export { PasswordComponent, PasswordMode } from './components/basic/password/password.component';
export type { PasswordComponentValue } from './components/basic/password/password.component';
export { DecoratorDirective } from './directives/decorator.directive';

// Import this barrel via a relative path to avoid Angular NG3004.

export const Password = [
  PasswordComponent,
  DecoratorDirective
];
